// Centralized store exports
export { useAuthStore } from './auth/authStore';
export { useDashboardStore } from './dashboard/dashboardStore';
export { useCoachingStore } from './coaching/coachingStore';
export { useUIStore } from './ui/uiStore';
export { useCacheStore } from './cache/cacheStore';
export { 
  useNutritionStore, 
  useNutritionGoals,
  useDailySummary,
  useTodaysMeals,
  useNutritionLoading,
  useNutritionError,
  useNutritionActions
} from './nutrition/nutritionStore';

// Legacy unified store (deprecated - use specific stores above)
export { useAppStore } from './appStore';

import { secureLogger } from '@/lib/secureLogger';

const logger = secureLogger.createSecureComponentLogger('StoreInitializer');

// Optimized store initialization with selective hydration
export const initializeStores = async () => {
  try {
    logger.info('Starting optimized store initialization');
    
    // Import optimized stores
    const { useAuthStore } = await import('./auth/authStore');
    const { useCacheStore } = await import('./cache/cacheStore');
    
    logger.info('Initializing auth store');
    await useAuthStore.getState().initialize();
    
    logger.info('Setting up cache cleanup');
    useCacheStore.getState().cleanup();
    
    logger.info('Optimized stores initialized successfully');
  } catch (error) {
    logger.error('Critical error during store initialization', error);
    throw error;
  }
};